import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Icon } from "@/lib/icons";
import { fillCopy } from "./contribution-kit-copy";
import { TASK_GUIDELINES, pickLocalized } from "./task-help.content";
import type { ContributionTaskKey } from "./task-registry";
import { useKitCopy } from "./use-kit-copy";

/**
 * The "Consignes" dialog of a task: its rules from task-help.content.ts,
 * plus optional extra lines a page adds (`extra`, already localised).
 */
export function TaskGuidelinesDialog({
  task,
  taskLabel,
  open,
  onOpenChange,
  extra = [],
}: {
  task: ContributionTaskKey;
  taskLabel: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  extra?: string[];
}) {
  const { copy, lang } = useKitCopy();
  const rules = [...TASK_GUIDELINES[task].map((rule) => pickLocalized(rule, lang)), ...extra];
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg rounded-xl">
        <DialogHeader>
          <DialogTitle className="text-lg font-semibold">{fillCopy(copy.guidelinesTitle, { task: taskLabel })}</DialogTitle>
          <DialogDescription className="sr-only">{copy.guidelines}</DialogDescription>
        </DialogHeader>
        <ul className="space-y-3">
          {rules.map((rule) => (
            <li key={rule} className="flex items-start gap-3 text-sm leading-6 text-foreground">
              <span className="mt-0.5 grid size-6 shrink-0 place-items-center rounded-full bg-brand/10 text-brand">
                <Icon name="check" className="size-3.5" />
              </span>
              <span>{rule}</span>
            </li>
          ))}
        </ul>
        <Button className="mt-2 h-11 w-full" onClick={() => onOpenChange(false)}>
          {copy.guidelinesDone}
        </Button>
      </DialogContent>
    </Dialog>
  );
}
